import { useRef, useEffect } from 'react';
import { scaleLinear } from 'd3-scale';
import { select } from 'd3-selection';
import { max, quantile } from 'd3-array';
import { axisBottom } from 'd3-axis';
import { line } from 'd3-shape';

export default function Histogram({ values, values2, avgLine }) {
  const ref = useRef();
  useEffect(() => {
    const width = 240;
    const height = 150;
    const margin = {top: 20, right: 10, bottom: 30, left: 10};
    const color = 'steelblue';

    if (!values) return;
    if (!values.NDVI_autohistogram) return;
    const bit = values.NDVI_autohistogram[1][0] - values.NDVI_autohistogram[0][0];
    const bins = values.NDVI_autohistogram.map(([x0, y]) => ({x0, x1: x0 + bit,  y}));

    const x = scaleLinear()
        .domain([quantile(bins, 0.05, d => d.x0), quantile(bins, 0.95, d => d.x1)])
        // .domain([bins[0].x0, bins[bins.length - 1].x1])
        .range([margin.left, width - margin.right])

    const y = scaleLinear()
      .domain([0, max(bins, d => d.y)]).nice()
      .range([height - margin.bottom, margin.top]);

    const xAxis = g => g
      .attr("transform", `translate(0,${height - margin.bottom})`)
      .call(axisBottom(x).ticks(width / 80 ).tickSizeOuter(0))
    // .call(g => g.append("text")
    //     .attr("x", width - margin.right)
    //     .attr("y", -4)
    //     .attr("fill", "currentColor")
    //     .attr("font-weight", "bold")
    //     .attr("text-anchor", "end")
    //     .text(xLabel))

    // const yAxis = g => g
    // .attr("transform", `translate(${margin.left},0)`)
    // .call(axisLeft(y).ticks(height / 40))
    // .call(g => select(".domain").remove())
    // // .call(g => select(".tick:last-of-type text").clone()
    //     // .attr("x", 4)
    //     // .attr("text-anchor", "start")
    //     // .attr("font-weight", "bold")
    //     // .text(yLabel))

    const svg = select(ref.current)
      .attr("viewBox", [0, 0, width, height]);

    svg.selectAll("*").remove();


      /// ======
      // and repeat
      /// ======
      if (values2 && values2.NDVI_autohistogram) {
        const bit2 = values2.NDVI_autohistogram[1][0] - values2.NDVI_autohistogram[0][0];
        const bins2 = values2.NDVI_autohistogram.map(([x0, y]) => ({x0, x1: x0 + bit2,  y}));

        const y2 = scaleLinear()
          .domain([0, max(bins2, d => d.y)]).nice()
          .range([height - margin.bottom, margin.top]);

        svg.append("g")
            .attr('name', 'values2')
            // .style("stroke", "darkred")
            .style("fill", "darkred")
            .style("opacity", 0.5)
            // .style("fill", "none")
          .selectAll("rect")
          .data(bins2)
          .join("rect")
            .attr("x", d => x(d.x0) + 1)
            .attr("width", d => Math.max(0, x(d.x1) - x(d.x0) - 1))
            .attr("y", d => y2(d.y))
            .attr("height", d => y2(0) - y2(d.y));
      }
      /// ======
      // end and repeat
      /// ======

    console.log(avgLine, y.range());
    if (avgLine) {
      svg.append("path")
        .attr('d', line()([[x(avgLine), y.range()[1]], [x(avgLine), y.range()[0]]]))
        .attr("stroke", "darkred")
        .attr("stroke-dasharray", "4 2")
        .style("opacity", 0.5)
    }


    svg.append("g")
          .attr('name', 'values')
        .attr("fill", color)
        .attr("fill-opacity", 0.75)
      .selectAll("rect")
      .data(bins)
      .join("rect")
        .attr("x", d => x(d.x0) + 1)
        .attr("width", d => Math.max(0, x(d.x1) - x(d.x0) - 1))
        .attr("y", d => y(d.y))
        .attr("height", d => y(0) - y(d.y));

      svg.append("g")
          .call(xAxis);
      
      // svg.append("g")
      //     .call(yAxis);




  }, [values, values2, avgLine]);
  return <svg ref={ref}>
  </svg>
}